import { CURRENT_TENANT } from '../constants/storageKeys';

export const getCurrentTenant = () => {
    return JSON.parse(window.localStorage.getItem(CURRENT_TENANT));
}

export const check = (feature) => {
    const currentTenant = getCurrentTenant();

    if (feature && currentTenant && currentTenant.features && currentTenant.features.length > 0) {
        return currentTenant && currentTenant.features.some(f => f === feature);
    }
    
    return false;
}